import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import ErrorPage from "commonComponents/errorPage/ErrorPage";
import PageHeader from "designV2/components/PageHeader";
import { Skeleton } from "designV2/components/Skeleton";
import TripPromotionForm from "./TripPromotionForm";
import "./tripPromotionForm.css";

const GET_PROMOTION = gql`
  query getTripPromotion($promotionId: ID!) {
    getTripPromotion(promotionId: $promotionId) {
      _id
      promotionCode
      condition
      type
      for
      canUse
      canNotUse
      useLimitCount
      percent
      maximumPromotion
      from
      to
    }
  }
`;

const EditPromotion = (props) => {
  const { loading, error, data } = useQuery(GET_PROMOTION, {
    variables: { promotionId: props.match.params.id },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="page tripPromotionPage">
        <main className="main">
          <PageHeader title="Edit promotion" />
          <Skeleton height={180} />
          <Skeleton height={180} />
        </main>
      </div>
    );
  }

  if (error || !data || !data.getTripPromotion) {
    return <ErrorPage />;
  }

  return <TripPromotionForm promotion={data.getTripPromotion} />;
};

export default EditPromotion;
